import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, X, Loader2 } from "lucide-react";

const PaymentResult = () => {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  const [status, setStatus] = useState("loading");
  const [ref, setRef] = useState("");
  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (!bookingId) { setStatus("error"); return; }
    fetch(`${API}/api/payments/${bookingId}`)
      .then((r) => r.json())
      .then((d) => { setStatus(d.payment_status || "error"); setRef(d.ref || ""); })
      .catch(() => setStatus("error"));
  }, [bookingId, API]);

  const paid = status === "PAID";
  return (
    <div className="pt-[68px] min-h-[100svh] bg-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center rounded-3xl border p-8" data-testid="payment-result"
        style={{ borderColor: paid ? "#25D366" : status === "loading" ? "#E9E5DE" : "#C0392B" }}>
        {status === "loading" ? (
          <><Loader2 className="animate-spin mx-auto text-[#2B4BFF]" size={40} /><p className="font-body text-[#5A607A] mt-4">Zahlung wird geprüft …</p></>
        ) : paid ? (
          <>
            <div className="w-16 h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center mx-auto mb-5"><Check size={32} /></div>
            <h1 className="font-heading font-bold text-2xl text-[#0B1533]">Zahlung erfolgreich!</h1>
            <p className="font-body text-sm text-[#5A607A] mt-3">Ihre Buchung {ref && <b>{ref}</b>} ist bezahlt und bestätigt. Vielen Dank!</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full bg-[#C0392B] text-white flex items-center justify-center mx-auto mb-5"><X size={32} /></div>
            <h1 className="font-heading font-bold text-2xl text-[#0B1533]">Zahlung nicht abgeschlossen</h1>
            <p className="font-body text-sm text-[#5A607A] mt-3">Status: {status}. Bitte versuchen Sie es erneut oder bezahlen Sie bei Ankunft.</p>
          </>
        )}
        <Link to="/" className="inline-flex items-center justify-center gap-2 bg-[#2B4BFF] text-white font-body font-semibold rounded-full px-8 py-3.5 mt-6 hover:bg-[#1E38D8] transition-colors">Zur Startseite</Link>
      </div>
    </div>
  );
};

export default PaymentResult;
